<template>
  <span>
    <v-tooltip bottom>
      <v-btn
        class="primary"
        icon
        height="30"
        slot="activator"
        @click="openExternalMap"
      >
        <v-icon>directions</v-icon>
      </v-btn>
      <span v-html="$t('parkingDetail.tooltip.howArrive')"></span>
    </v-tooltip>

    <template v-if="isLogged">
      <v-tooltip bottom v-if="isFavorite">
        <v-btn
          class="primary"
          icon
          :loading="favLoading"
          :disabled="favLoading"
          @click="toggleFavorite"
          slot="activator"
        >
          <v-icon>favorite</v-icon>
        </v-btn>
        <span v-html="$t('parkingDetail.tooltip.removeFavourite')"></span>
      </v-tooltip>

      <v-tooltip bottom v-else>
        <v-btn
          class="primary"
          icon
          :loading="favLoading"
          :disabled="favLoading"
          @click="toggleFavorite"
          slot="activator"
        >
          <v-icon>favorite_border</v-icon>
        </v-btn>
        <span v-html="$t('parkingDetail.tooltip.addFavourite')"></span>
      </v-tooltip>
    </template>
  </span>
</template>

<script>
import parkingService from '@/services/parkingService';
import utilService from '@/services/utilService';
import store from '@/store';

export default {
  name: 'ParkingDetailButtons',
  props: {
    parking: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isLogged() {
      return store.state.isLogged;
    },
    getBackPath() {
      if (store.state.isLogged) {
        return this.$i18n.t('urlUser');
      } else {
        return this.$i18n.t('urlParkingPage');
      }
    },
  },
  watch: {
    parking: function (value) {
      if (typeof value === 'undefined') {
        this.isFavorite = false;
        return;
      }
      this.isFavorite = value.isFavourite;
    },
  },
  data() {
    return {
      isFavorite: false,
      favLoading: false,
      favLoader: null,
      hasBLE: false,
      hasAPR: false,
      countryHasBle: store.state.countrySelected.hasBle,
    };
  },
  methods: {
    async toggleFavorite() {
      this.favLoader = 'loading';
      this.favLoading = true;

      let params = {
        id: this.parking.id,
        customerId: store.state.user.id,
      };

      let resp = await parkingService.toggleFavorite(params);
      if (resp.error) {
      } else {
        this.isFavorite = resp.data;
      }
      this.favLoader = null;
      this.favLoading = false;
    },

    openExternalMap() {
      utilService.openExternalMap(
        this.parking.lat,
        this.parking.lon,
        this.parking.address
      );
    },
  },
};
</script>
